import {CurrencyCode, MoneyRepresentation, formatCurrency} from '@raison/types';
import React from 'react';
import {useModalsToggler} from '~/entities/dialogs';
import questionImg from '~/shared/legacy_res/img/svg/operations/question-line.svg';
import {Slot} from '~/shared/utils/types';
import FinalRateModal from '../.././../../Shared/FinalRateModal';
import styles from '../../ExchangeFiat.module.scss';

interface RenderExchangeDetailsProps {
    readonly baseCurrency: CurrencyCode;

    readonly rateMoneyRepresentation: MoneyRepresentation;

    readonly resultMoneyRepresentation: MoneyRepresentation;
}

export const renderExchangeDetails = ({
    baseCurrency,
    rateMoneyRepresentation,
    resultMoneyRepresentation,
}: RenderExchangeDetailsProps): [Slot, Slot][] => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {changeFlag} = useModalsToggler('generalModals');

    return [
        [
            <div key='rate'>
                Rate <img src={questionImg} alt='Question' onClick={() => changeFlag('finalRateModal')} />
                <div className={styles.resetNoWrap}>
                    <FinalRateModal />
                </div>
            </div>,
            `1 ${baseCurrency} = ${formatCurrency(rateMoneyRepresentation)}`,
        ],
        ['Total receive', formatCurrency(resultMoneyRepresentation)],
    ];
};
